<template>
    <div style="margin-top: -64px; position: relative">
        <v-app-bar
                app
                style="background: rgba(27, 34, 46, 0.6);"
                absolute
                class="white--text"
                flat
        >
        <v-container class="py-0 fill-height custom-container">
            <div class="d-flex align-center cursor-pointer">
                <v-img contain @click="$router.replace('/');" src="/general/logo-footer.svg" :max-width="$vuetify.breakpoint.mdAndUp ? '240px' : '150px'"></v-img>
            </div>
            <v-spacer></v-spacer>
            <!-- <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text class="playfair-display white--text">
                    Services
                </v-btn>
                <v-btn text class="playfair-display white--text">
                    How it Works?
                </v-btn>
                <v-btn text class="playfair-display white--text">
                    For Clinics And Hospitals
                </v-btn>
            </v-toolbar-items> -->
            <v-spacer></v-spacer>
            <v-toolbar-items>

                <v-btn @click="goToDoctorPortal" v-if="!userInfo"
                       class=" hidden-sm-and-down playfair-display black--text white"
                       style="height: 28px !important; margin-top: 16px; border-radius: 4px">
                    Login / Register
                </v-btn>

                <v-menu offset-y v-if="!userInfo">
                    <template v-slot:activator="{ on }">
                        <v-btn text v-on="on" icon class="hidden-md-and-up">
                            <v-icon color="white">mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="goToDoctorPortal"
                                     class="playfair-display">
                            <v-list-item-title>Login</v-list-item-title>
                        </v-list-item>
                        <!--
                        <v-list-item
                                class="playfair-display">
                            <v-list-item-title>Services</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                class="playfair-display">
                            <v-list-item-title>How it Works?</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                                class="playfair-display">
                            <v-list-item-title>For Clinics And Hospitals</v-list-item-title>
                        </v-list-item>
                        -->
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-container>
        </v-app-bar>
        <v-container fluid class="px-0 providers-banner-0">
            <v-container class="">
                <v-row style="min-height: 100vh" align="center" class="white--text">
                    <v-col cols="12" sm="12" md="10">
                        <h2 class="font-weight-bold playfair-display font-60 mt-12">Simplify Patient Healthcare
                        </h2>
                        <h2 class="font-weight-bold playfair-display font-45 mb-6">
                            Together
                            <span class="font-weight-light font-32">
                            with HealthyAlways
                        </span>
                        </h2>

                        <br><br>
                        <h2 class="font-24 font-weight-medium mb-3">
                            A practice growth solution defining your global presence and reach.
                        </h2>

                        <div class="opacity-8" style="font-size: 18px">
                            HealthyAlways helps you dominate your local market and finds opportunities to grow your
                            practice by comparing and analyzing your Google rank, web presence, website, and online
                            reputation. It also empowers your practice with telehealth solutions giving you the tools to
                            drive your professional growth.

                        </div>
                        <br> <br>
                        <v-btn @click='goToDoctorPortal' rounded class="white black--text" large>
                            Start your Free Trial
                            <v-icon right>mdi-arrow-right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>

        <!-- Cards -->
        <v-container class="mb-12">
            <v-row>
                <v-col cols="12" sm="12" class="text-center">
                    <br> <br>
                    <h1 class="font-32 playfair-display font-weight-bold">Why do doctors partner with
                        HealthyAlways?</h1>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="d-flex" style="flex-direction:column">
                    <v-card
                            class="banner-cards card-blue"
                            outlined
                    >
                        <v-list class="pa-0 wrap-normal-list">
                            <v-list-item three-line class=" pa-9">
                                <v-list-item-content>
                                    <!--                                <div class="overline mb-4">OVERLINE</div>-->
                                    <v-list-item-title class="mb-4 font-26"> Increase Patient Outreach
                                    </v-list-item-title>
                                    <v-list-item-subtitle style="font-size: 18px">
                                        We will help you create a prominent presence online, boost your search rankings
                                        and
                                        deliver innovative medical marketing strategies through search engine
                                        optimization
                                        (SEO) & social media
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-avatar
                                        tile
                                        :size="iconSize"
                                >
                                    <svg width="150" height="150" viewBox="0 0 150 150" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M137.5 53.125C137.5 61.7544 130.504 68.75 121.875 68.75C113.246 68.75 106.25 61.7544 106.25 53.125C106.25 44.4956 113.246 37.5 121.875 37.5C130.504 37.5 137.5 44.4956 137.5 53.125ZM81.25 71.875C81.25 83.9562 71.4562 93.75 59.375 93.75C47.2937 93.75 37.5 83.9562 37.5 71.875C37.5 59.7938 47.2937 50 59.375 50C71.4562 50 81.25 59.7938 81.25 71.875Z"
                                              fill="#C3E0DD"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M25 31.25C26.7259 31.25 28.125 32.6491 28.125 34.375V115.625H125C126.726 115.625 128.125 117.024 128.125 118.75C128.125 120.476 126.726 121.875 125 121.875H25C23.2741 121.875 21.875 120.476 21.875 118.75V34.375C21.875 32.6491 23.2741 31.25 25 31.25ZM116.369 62.2005V72.6188C116.369 74.3444 117.767 75.7438 119.494 75.7438C121.219 75.7438 122.619 74.3444 122.619 72.6188V54.9409C122.619 53.215 121.219 51.8159 119.494 51.8159H101.816C100.09 51.8159 98.6912 53.215 98.6912 54.9409C98.6912 56.6668 100.09 58.0659 101.816 58.0659H111.664L85.5581 84.1719L69.0181 67.6319C67.8013 66.415 65.8294 66.4106 64.6075 67.6231L36.3713 95.6369C35.1461 96.8525 35.1383 98.8313 36.3539 100.056C37.5694 101.281 39.5481 101.289 40.7732 100.074L66.7994 74.2519L83.3488 90.8013C84.5688 92.0213 86.5475 92.0213 87.7681 90.8013L116.369 62.2005Z"
                                              fill="#4A4A63"/>
                                    </svg>

                                </v-list-item-avatar>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="d-flex" style="flex-direction:column">
                    <v-card
                            class="banner-cards card-pink"
                            outlined
                    >
                        <v-list-item three-line class="wrap-normal-list pa-9">
                            <v-list-item-content>
                                <!--                                <div class="overline mb-4">OVERLINE</div>-->
                                <v-list-item-title class="mb-4 font-26"> Offer Premium Tele-health
                                    Solutions
                                </v-list-item-title>
                                <v-list-item-subtitle style="font-size: 18px">
                                    With HealthyAlways provide virtual care to your patients
                                    through Video/Audio consultations and modernize your front office with great ease
                                    and convenience.
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar
                                    tile
                                    :size="iconSize"
                            >
                                <svg width="150" height="150" viewBox="0 0 150 150" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M87.5 31.25H31.25C27.7982 31.25 25 34.0482 25 37.5V137.5C25 140.952 27.7982 143.75 31.25 143.75H56.25"
                                          fill="#F2D3CE"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M40.6296 25C40.6296 23.2741 42.0286 21.875 43.7546 21.875H93.7544C95.4806 21.875 96.8794 23.2741 96.8794 25V50C96.8794 51.7259 98.2787 53.125 100.004 53.125C101.731 53.125 103.129 51.7259 103.129 50V25C103.129 19.8223 98.9325 15.625 93.7544 15.625H43.7546C38.5769 15.625 34.3795 19.8223 34.3795 25V88.6913L8.45998 103.656C6.9653 104.519 6.45323 106.43 7.31617 107.924C8.17911 109.419 10.0903 109.931 11.585 109.069L54.8862 84.0687C56.3596 83.2181 58.2376 83.7031 59.1174 85.1488C59.116 85.15 59.1174 85.1613 59.1202 85.1819C59.1341 85.2869 59.1819 85.6488 59.0724 86.3938C58.9267 87.3844 58.5654 88.62 58.0343 89.9075C57.5071 91.1856 56.8591 92.4031 56.2109 93.36C55.8877 93.8375 55.5874 94.2162 55.3282 94.4931C55.2001 94.63 55.0934 94.73 55.0107 94.7994C54.9312 94.8662 54.8893 94.8919 54.8864 94.8937C54.8862 94.8937 54.8862 94.8937 54.8864 94.8937L30.5293 108.956C27.9607 110.439 26.353 112.979 25.79 115.66C25.3142 117.925 24.4715 121.111 23.1013 124.077C21.7022 127.106 19.9363 129.506 17.835 130.719C16.3403 131.582 15.8282 133.493 16.6912 134.988C17.5541 136.483 19.4653 136.995 20.96 136.132C24.7016 133.971 27.1602 130.194 28.7753 126.698C30.4193 123.138 31.3805 119.449 31.9065 116.944C32.1524 115.774 32.8155 114.853 33.6543 114.369L34.3795 113.95V125C34.3795 130.177 38.5769 134.375 43.7546 134.375H93.7544C98.9325 134.375 103.129 130.177 103.129 125V118.75C103.129 117.024 101.731 115.625 100.004 115.625C98.2787 115.625 96.8794 117.024 96.8794 118.75V125C96.8794 126.726 95.4806 128.125 93.7544 128.125H43.7546C42.0286 128.125 40.6296 126.726 40.6296 125V110.342L58.0112 100.306C59.3855 99.5131 60.5291 98.13 61.3857 96.865C62.3023 95.5119 63.1444 93.91 63.8125 92.29C64.4762 90.6794 65.0156 88.9381 65.2562 87.3025C65.4744 85.8156 65.5462 83.7825 64.5675 82.0875C61.9789 77.6031 56.2452 76.0669 51.7612 78.6556L40.6296 85.0825V25ZM59.3796 31.25C59.3796 29.5241 60.7786 28.125 62.5044 28.125H75.0044C76.7306 28.125 78.1294 29.5241 78.1294 31.25C78.1294 32.9759 76.7306 34.375 75.0044 34.375H62.5044C60.7786 34.375 59.3796 32.9759 59.3796 31.25ZM105.949 60.5686C105.112 57.9935 102.712 56.25 100.004 56.25C97.2969 56.25 94.8969 57.9935 94.0606 60.5686L89.8506 73.5244H76.2281C73.5206 73.5244 71.1206 75.2681 70.2837 77.8431C69.4475 80.4181 70.3637 83.2394 72.5544 84.8306L83.5756 92.8381L79.3656 105.794C78.5294 108.369 79.4456 111.19 81.6362 112.782C83.8269 114.373 86.7931 114.373 88.9837 112.782L100.004 104.774L111.026 112.782C113.216 114.373 116.182 114.373 118.373 112.782C120.563 111.19 121.48 108.369 120.643 105.794L116.434 92.8381L127.454 84.8306C129.645 83.2394 130.562 80.4181 129.725 77.8431C128.888 75.2681 126.489 73.5244 123.781 73.5244H110.158L105.949 60.5686ZM76.2281 79.7744H94.3919L100.004 62.5L105.618 79.7744H123.781L109.086 90.4506L114.699 107.726L100.004 97.0494L85.31 107.726L90.9225 90.4506L76.2281 79.7744Z"
                                          fill="#4A4A63"/>
                                </svg>
                            </v-list-item-avatar>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="d-flex" style="flex-direction:column">
                    <v-card
                            class="banner-cards"
                            outlined
                    >
                        <v-list-item three-line class="wrap-normal-list pa-9">
                            <v-list-item-content>
                                <!--                                <div class="overline mb-4">OVERLINE</div>-->
                                <v-list-item-title class="mb-4 font-26"> Improve Retention and Track
                                    your growth
                                </v-list-item-title>
                                <v-list-item-subtitle style="font-size: 18px">
                                    Your personalized portal will give you performance insights and data on
                                    appointments, billings, web and SEO statistics.
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar
                                    tile
                                    :size="iconSize"
                            >
                                <svg width="150" height="150" viewBox="0 0 150 150" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M84.375 106.25C106.812 106.25 125 88.0619 125 65.625C125 43.1884 106.812 25 84.375 25C61.9384 25 43.75 43.1884 43.75 65.625C43.75 88.0619 61.9384 106.25 84.375 106.25Z"
                                          fill="#E9C68E"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M34.375 34.375C34.375 32.6491 32.9759 31.25 31.25 31.25C29.5241 31.25 28.125 32.6491 28.125 34.375V118.75C28.125 120.476 29.5241 121.875 31.25 121.875H118.75C120.476 121.875 121.875 120.476 121.875 118.75C121.875 117.024 120.476 115.625 118.75 115.625H34.375V34.375ZM62.5 75C62.5 73.2744 61.1009 71.875 59.375 71.875C57.6491 71.875 56.25 73.2744 56.25 75V106.25C56.25 107.976 57.6491 109.375 59.375 109.375C61.1009 109.375 62.5 107.976 62.5 106.25V75ZM96.875 59.375C98.6006 59.375 100 60.7741 100 62.5V106.25C100 107.976 98.6006 109.375 96.875 109.375C95.1494 109.375 93.75 107.976 93.75 106.25V62.5C93.75 60.7741 95.1494 59.375 96.875 59.375ZM50 93.75C50 92.0244 48.6009 90.625 46.875 90.625C45.1491 90.625 43.75 92.0244 43.75 93.75V106.25C43.75 107.976 45.1491 109.375 46.875 109.375C48.6009 109.375 50 107.976 50 106.25V93.75ZM84.375 71.875C86.1006 71.875 87.5 73.2744 87.5 75V106.25C87.5 107.976 86.1006 109.375 84.375 109.375C82.6494 109.375 81.25 107.976 81.25 106.25V75C81.25 73.2744 82.6494 71.875 84.375 71.875ZM75 43.75C75 42.0241 73.6006 40.625 71.875 40.625C70.1494 40.625 68.75 42.0241 68.75 43.75V106.25C68.75 107.976 70.1494 109.375 71.875 109.375C73.6006 109.375 75 107.976 75 106.25V43.75Z"
                                          fill="#4A4A63"/>
                                </svg>


                            </v-list-item-avatar>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="6" class="d-flex" style="flex-direction:column">
                    <v-card
                            class="banner-cards card-purple"
                            outlined
                    >
                        <v-list-item three-line class="wrap-normal-list pa-9">
                            <v-list-item-content>
                                <!--                                <div class="overline mb-4">OVERLINE</div>-->
                                <v-list-item-title class="mb-4 font-26"> Get synchronized with
                                    HealthyAlways' connected care
                                </v-list-item-title>
                                <v-list-item-subtitle style="font-size: 18px">
                                    With the HealthyAlways, providers can plug in their EMR & EHR systems to
                                    benefit from our
                                    innovative solutions to create an integrated experience for their
                                    patients and their teams.
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar
                                    tile
                                    :size="iconSize"
                            >
                                <svg width="150" height="150" viewBox="0 0 150 150" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M40.625 93.75C63.0619 93.75 81.25 75.5619 81.25 53.125C81.25 30.6884 63.0619 12.5 40.625 12.5C18.1884 12.5 0 30.6884 0 53.125C0 75.5619 18.1884 93.75 40.625 93.75Z"
                                          fill="#A4B2D9"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M75 21.875C45.6599 21.875 21.875 45.6599 21.875 75C21.875 104.34 45.6599 128.125 75 128.125C104.34 128.125 128.125 104.34 128.125 75C128.125 45.6599 104.34 21.875 75 21.875ZM53.6247 33.2712C40.8675 39.8192 31.5047 52.0453 28.8733 66.6125C31.5844 65.26 35.0038 64.1 38.8867 63.1294C39.7528 62.9131 40.6479 62.7044 41.5705 62.5044C43.0132 53.1494 46.0467 44.7183 50.2529 37.9884C51.2973 36.3173 52.4235 34.7388 53.6247 33.2712ZM28.8733 83.3875C31.5047 97.9544 40.8675 110.181 53.6247 116.729C52.4235 115.261 51.2973 113.682 50.2529 112.012C46.0467 105.282 43.0132 96.8506 41.5705 87.4956C40.6479 87.2956 39.7528 87.0869 38.8867 86.8706C35.0038 85.9 31.5844 84.74 28.8733 83.3875ZM96.375 116.729C109.132 110.181 118.496 97.9544 121.127 83.3875C118.416 84.74 114.996 85.9 111.113 86.8706C110.247 87.0869 109.352 87.2956 108.429 87.4956C106.987 96.8506 103.953 105.282 99.7469 112.012C98.7025 113.682 97.5762 115.261 96.375 116.729ZM121.127 66.6125C118.416 65.26 114.996 64.1 111.113 63.1294C110.247 62.9131 109.352 62.7044 108.429 62.5044C106.987 53.1494 103.953 44.7183 99.7469 37.9884C98.7025 36.3173 97.5762 34.7388 96.375 33.2712C109.132 39.8192 118.496 52.0454 121.127 66.6125ZM75 28.125C82.1631 28.125 89.1212 32.7792 94.4469 41.3009C97.8431 46.7346 100.451 53.5766 101.886 61.2954C94.0275 60.0714 84.8138 59.375 75 59.375C65.1862 59.375 55.9724 60.0714 48.1145 61.2954C49.5492 53.5766 52.1569 46.7346 55.5529 41.3009C60.879 32.7792 67.8369 28.125 75 28.125ZM75 65.625C64.6175 65.625 55.0451 66.4281 47.2119 67.7763C46.9904 70.1275 46.875 72.54 46.875 75C46.875 77.46 46.9904 79.8725 47.2119 82.2237C55.0451 83.5719 64.6175 84.375 75 84.375C85.3825 84.375 94.955 83.5719 102.788 82.2237C103.009 79.8725 103.125 77.46 103.125 75C103.125 72.54 103.009 70.1275 102.788 67.7763C94.955 66.4281 85.3825 65.625 75 65.625ZM55.5529 108.699C52.1569 103.266 49.5492 96.4231 48.1145 88.7044C55.9724 89.9287 65.1862 90.625 75 90.625C84.8138 90.625 94.0275 89.9287 101.886 88.7044C100.451 96.4231 97.8431 103.266 94.4469 108.699C89.1212 117.221 82.1631 121.875 75 121.875C67.8369 121.875 60.879 117.221 55.5529 108.699Z"
                                          fill="#4A4A63"/>
                                </svg>

                            </v-list-item-avatar>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" class="text-center">
                    <br>
                    <v-btn @click='goToDoctorPortal' class="accent white--text" large rounded>
                        Register With Us
                        <v-icon right>mdi-arrow-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

        </v-container>

        <!--        Convenience -->

        <v-container fluid class=" px-0">
            <v-container class="">
                <v-row style="" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="font-32 playfair-display font-weight-bold">
                            Deliver a healthcare experience that your patients love.
                        </h1>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <v-container fluid class="providers-banner-1 px-0">
            <v-container class="">
                <v-row style="min-height: 60vh" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">

                    </v-col>
                    <v-col cols="12" sm="12" md="5" offset-md="7">
                        <v-card class="white" style="box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);border-radius: 10px;">
                            <v-card-text class="pa-8">
                                <h1 class="text-center black--text font-34">HealthyAlways</h1>
                                <br>
                                <v-divider class="grey"></v-divider>
                            </v-card-text>
                            <v-list class="pa-2 wrap-normal-list">
                                <!--                                <v-list-item-group color="primary">-->
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="teal" large rounded>mdi-check-circle</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="grey--text text--darken-2 font-20">
                                            Simplify your day-to-day, foster patients trust
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="teal" large rounded>mdi-check-circle</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="grey--text text--darken-2 font-20">
                                            Leverage data to optimize outcomes, Integrated analytics
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="teal" large rounded>mdi-check-circle</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="grey--text text--darken-2 font-20">
                                            Reverse the cost trend, reduce administrative waste
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon color="teal" large rounded>mdi-check-circle</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="grey--text text--darken-2 font-20">
                                            Drive smart engagement, modernize patient experience
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <!--                                </v-list-item-group>-->
                            </v-list>
                            <v-card-text class="px-8 pb-8">
                                <h3 class="font-weight-medium text-center black--text font-20">
                                    More value, lower total investment
                                </h3>
                            </v-card-text>
                        </v-card>

                    </v-col>
                </v-row>
            </v-container>
        </v-container>

        <!--        Attention-->
        <v-container class="py-12">
            <v-row style="min-height: 60vh" align="center">
                <v-col cols="12" sm="12" class="text-center">
                    <h1 class="font-32 playfair-display font-weight-bold">Why we're different?</h1>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                    <h2 class="grey--text text--darken-2 font-weight-regular font-26 text-center">
                        We know that maintaining an online presence, managing your reputation, improving on your search result rankings, and modernizing your patients experience is chaotic for you as well as your team. That's why many Doctors and Healthcare professionals choose HealthyAlways. We replace a disjointed experience with one connected system to drive more value for you and your patients. 
                    </h2>
                </v-col>

                <v-col cols="12" sm="12" class="text-center">
                    <v-btn @click='goToDoctorPortal' href="#" class="accent white--text" large rounded ripple
                           width="200px">
                        Connect With Us
                        <v-icon right>mdi-arrow-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

<!-- app link -->
        <v-container fluid class="lightPinkBackground" id="provider-app">
            <v-container class="">
                <v-row style="" class="home-rows" align="center">
                    <v-col cols="12" sm="12" offset-md="1"  md="5" class="text-center">
                        <v-img class="mt-10" style="margin:auto;" max-height="450" contain src="/general/provider.png"></v-img>
                    </v-col>

                    <v-col cols="12" sm="12" md="6" class="">
                        <v-col cols="12" sm="12" md="12" offset-md="0" class="ma-0 pa-0 ml-md-11 text-sm-center text-md-left">
                            <h1 class="font-32 playfair-display font-weight-bold">Download HealthyAlways+ app</h1>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" offset-md="0" class="d-flex justify-center justify-md-start">
                            <v-list dense class="lightPinkBackground" style="max-width:500px;">
                                <v-list-item
                                 v-for="feature in providerFeatures" 
                                 class="ma-0 pa-0"
                                 :key="feature.title"
                                 >
                                    <v-list-item-icon class="ma-0 pa-0 align-self-center">
                                        <v-icon class="ma-0 pa-0" style="color:#ffa000" small right>mdi-check</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content class="ma-0 pa-0 ml-2 text-left">{{ feature.title }}</v-list-item-content>                                    
                                </v-list-item>    
                            </v-list>                                                        
                        </v-col>
                        <v-col class="mt-8 ma-0 pa-0">
                            <div class="d-flex justify-center justify-sm-center justify-md-start mt-10 ml-md-12">
                                <a target="_blank" :href="doctor_app_link">
                                    <v-img width="130px" src="/general/download-android.png"></v-img>
                                </a>
                            </div>
                            
                        </v-col>
                    </v-col>
                    
                                        
                </v-row>
            </v-container>
        </v-container>

        <!--        Articles -->
        <v-container fluid class="lightPinkBackground mt-10">
            <v-container class="">
                <v-row style="min-height: 60vh" align="center">
                    <v-col cols="12" sm="12" md="12" class="text-center">
                        <h1 class="font-32 playfair-display font-weight-bold">Questions we often get from
                            Doctors/Healthcare Providers</h1>
                    </v-col>
                    <v-col cols="12" sm="12">
                    
                        <v-expansion-panels flat class="lightPinkBackground font-weight-medium" v-model="expandedList">
                            <v-expansion-panel 
                                v-for="(questionAnswer,i) in questionsList"
                                :key="questionAnswer.question"
                                class="lightPinkBackground question-expansions"
                                
                            >
                                <v-expansion-panel-header
                                    class="grey--text text--darken-3 font-18"
                                    :class="expandedList === i ? 'weight-semibold' : 'weight-light'"
                                > 
                                    {{ questionAnswer.question }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <span class="grey--text weight-regular font-16 text--darken-1"
                                          v-html="questionAnswer.answer"></span>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <v-col>
                    <div style="text-decoration:underline;" class="ml-6 font-12 weight-medium text-left cursor-pointer" v-if="!viewMoreQuestions" @click="expand()">View More</div>
                    <div style="text-decoration:underline;" class="ml-6 font-12 weight-medium text-left cursor-pointer" v-if="viewMoreQuestions == true" @click="collapse(true)">View Less</div>
                    
                    
                    </v-col>

                </v-row>
            </v-container>
        </v-container>

        <v-container>
            <v-row style="min-height: 60vh" align="center" id="take_care">
                <v-col cols="12" sm="12" md="10" offset-md="1" class="text-center">
                    <br><br>
                    <v-card class="providers-banner-2 py-12 white--text" style="border-radius: 30px;" elevation="8">
                        <v-card-text class="pa-8 text-center">
                            <h1 class="font-32 playfair-display font-weight-medium white--text">Take better care of your
                                patients</h1>
                            <br>
                            <br>
                            <h2 class=" font-24 font-weight-medium white--text">
                                Discover the HealthyAlways difference with tools specially built for your practice.
                            </h2>
                            <br>
                            <h4 style="font-size: 18px; line-height: 28px; color: rgba(255, 255, 255, 0.8);"
                                class="font-weight-light">
                                We're changing how healthcare services works. Maximize the value of your healthcare
                                services and have more control over your costs.
                                We’ve created a practice growth solution combining virtual care, digital patient intake,
                                easy-to-use communication tools and effective online strategies.
                            </h4>
                            <br> <br>
                            <v-btn @click='goToDoctorPortal' class="white black--text" rounded text>
                                Let's Get Started
                                <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid class="lightPinkBackground" style="height: 40vh; margin-top: -250px">
        </v-container>
    </div>
</template>

<script>
    export default {
        name: "Home",
        mounted() {
            this.viewMoreQuestions = false
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            this.getFaqList()
        },
        
        data() {
            return {
                iconSize: 110,
                doctor_app_link:process.env.VUE_APP_API_URL+"/drapp",
                originalQuestionsList:[],
                questionsList: [],
                viewMoreQuestions:true,
                providerFeatures: [
                    { title: 'Manage your profile'},
                    { title: 'Provide online consultation to patients'},
                    { title: 'Manage your clinic'},
                    { title: 'See patient records from anywhere'},
                ],
                expandedList:"",
            }
        },
        methods: {
            expand(){
                this.viewMoreQuestions = true
                this.updateQuestionsList()
            },
            collapse(scroll_down){
                this.viewMoreQuestions = false
                this.updateQuestionsList()
                if(scroll_down)
                    document.getElementById('take_care').scrollIntoView();
            },
            updateQuestionsList(){
                if(this.viewMoreQuestions){
                    this.questionsList = this.originalQuestionsList
                }else{
                    this.questionsList = this.originalQuestionsList.slice(0,5)
                    
                }
            },
            getFaqList() {
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/faq/get-doctor-faq-list`)
                    .then((response) => {
                        this.originalQuestionsList = response.data.data;                                                
                        this.collapse(false)
                    }).catch((error) => {
                    console.log(error);
                    this.isLoading = false;
                });
            },
            goTo(routeName) {
                this.$router.push({name: routeName});
            },
            goToDoctorPortal() {
                window.open(process.env.VUE_APP_API_URL, '_blank')
            },
            handleResize() {
                if (this.$vuetify.breakpoint.mdAndUp) {
                    this.iconSize = 110;
                } else {
                    this.iconSize = 70;
                }
            }
        }
    }
</script>

<style scoped>
    .banner-cards {
        border: 1px solid #E9C68E !important;
        border-left: 20px solid #E9C68E !important;
        height: 100%;
    }

    .banner-cards.card-blue {
        border: 1px solid #C3E0DD !important;
        border-left: 20px solid #C3E0DD !important;
    }

    .banner-cards.card-pink {
        border: 1px solid #F2D3CE !important;
        border-left: 20px solid #F2D3CE !important;
    }

    .banner-cards.card-purple {
        border: 1px solid #A4B2D9 !important;
        border-left: 20px solid #A4B2D9 !important;
    }

    .banner-cards .card__actions {
        padding: 4px 8px !important;
    }

    .lightPinkBackground.question-expansions {
        border-bottom: 1px solid #ccc !important;
        border-color: #ccc !important;
    }

    .question-expansions button {
        font-size: 20px;
    }

    @media screen and (max-width: 1000px) {
        .banner-cards {
            height: auto;
        }
    }
</style>